import '../App.css';
import { useState, useEffect } from "react";

function CountDown() {

    const [timeLeft, setTimeLeft] = useState(0);

    function getNextMonthStart() {
        const now = new Date();
        return new Date(now.getFullYear(), now.getMonth() + 1, 1, 0, 0, 0, 0);
    }

    
    useEffect(() => {
        function getTimeRemaining() {
            const now = new Date();
            const target = getNextMonthStart();
            return Math.max(0, target - now);
        }


        const timer = setInterval(() => {
            setTimeLeft(getTimeRemaining());
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    function formatTime(ms) {

        const totalSeconds = Math.floor(ms / 1000);
        const totalDays = Math.floor(totalSeconds / 86400);

        if (totalDays >= 1) {
            return `${totalDays} day${totalDays !== 1 ? "s" : ""} remaining`;
        }

        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        return `${hours}h ${minutes}m ${seconds}s`;
    }

    return (
        <p style={{marginBottom: "60px"}}>{formatTime(timeLeft)}</p>
    );
}

export default CountDown;